export default {
	accessToken: "",
	idToken: "",
	expiry: true,
};
